//include 12
/*
jQuery(function(){
	function loadVideos(){
	    $("video").each(function(index){
	            $(this).get(0).load();
	            $(this).get(0).addEventListener("canplaythrough", function(){
	                this.play();
	                this.pause();
	            });
	    });
	}

	$('.video-wrapper').each(function(){
		var video = $(this).find('video').get(0);
		var playButton = $(this).find('.video-controls .play').get(0);
		var fullscreenButton = $(this).find('.video-controls .fullscreen').get(0);

		playButton.addEventListener("click", function() {
		  if (video.paused == true) {
		    // Play the video
		    video.play();
		    $(playButton).css('opacity','0');
		  } else {
		    // Pause the video
		    video.pause();
		    $(playButton).css('opacity','1');
		  }
		});

		if(fullscreenButton){
			fullscreenButton.addEventListener("click", function() {
				if (video.paused == false) {
				    // Pause the video
				    video.pause();
				    $(playButton).css('opacity','1');
				}
                var url = "";
				if($(this).parents('.video-wrapper').find('source').attr('data-highres')){
					url = $(this).parents('.video-wrapper').find('source').attr('data-highres');
				}
				else{
					url = $(this).parents('.video-wrapper').find('source').attr('src');
				}
				// console.log('url '+url);
				var lightbox = lity();
			    lightbox(url);
			});
		}

	});

	$('.videogallery .video-wrapper').each(function(){
		var video = $(this).find('video').get(0);
		var playButton = $(this).find('.video-controls .play').get(0);

		playButton.addEventListener("click", function() {
		    var url = "";
			if($(this).parents('.video-wrapper').find('source').attr('data-highres')){
				url = $(this).parents('.video-wrapper').find('source').attr('data-highres');
			}
			else{
				url = $(this).parents('.video-wrapper').find('source').attr('src');
			}
			// console.log('url '+url);
			var lightbox = lity();
		    lightbox(url);
		});
	});
});
	//*/